/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_getHolder.js
// module id = 331
// module chunks = 4